module.exports = __webpack_public_path__ + "static/media/dollar-icon.ffdea458.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dollar-icon.svg
// module id = ./src/assets/icons/dollar-icon.svg
// module chunks = 0